/**
 * Invoice Model - Processes API responses for invoice data
 */

export const getInvoices = (response) => {
  if (response && response.data && response.data.success === true) {
    const invoices = Array.isArray(response.data.data)
      ? response.data.data.map((inv) => ({
          id: inv.id,
          slack: inv.slack,
          invoice_number: inv.invoice_number,
          invoice_reference: inv.invoice_reference,
          bill_to: inv.bill_to,
          bill_to_id: inv.bill_to_id,
          bill_to_code: inv.bill_to_code,
          bill_to_name: inv.bill_to_name,
          invoice_date: inv.invoice_date,
          invoice_due_date: inv.invoice_due_date,
          total_order_amount: inv.total_order_amount,
          status: inv.status,
          status_data: inv.status_data || null,
          invoice_pdf_url: inv.invoice_pdf_url || null,
          created_at: inv.created_at,
          updated_at: inv.updated_at,
          createdAt: inv.createdAt || inv.created_at,
          updatedAt: inv.updatedAt || inv.updated_at,
          created_by: inv.created_by,
          updated_by: inv.updated_by,
          order_id: inv?.order_id || null,
          total_order_amount_rounded: inv?.total_order_amount_rounded || null
        }))
      : []

    return {
      success: true,
      total: response.data.total || invoices.length,
      data: invoices
    }
  }
  return {
    success: false,
    message: response?.data?.message || 'Failed to fetch invoices',
    data: []
  }
}

export const mapBillToList = (response) => {
  if (response && response.data && response.data.success === true) {
    const data = Array.isArray(response.data.data) ? response.data.data : []
    // Normalize to { slack, label }
    const normalized = data.map((item) => ({
      slack:
        item.slack ||
        item.id ||
        item.customer_slack ||
        item.supplier_slack ||
        item.code ||
        item.value ||
        '',
      label:
        item.label ||
        item.name ||
        item.customer_name ||
        item.supplier_name ||
        item.title ||
        item.display ||
        ''
    }))
    return { success: true, data: normalized }
  }
  return { success: false, data: [] }
}

export const mapProductsForInvoice = (response) => {
  if (
    response &&
    response.data &&
    (response.data.success === true || Array.isArray(response.data))
  ) {
    const list = response.data.data || response.data
    const products = Array.isArray(list)
      ? list.map((p) => ({
          product_slack: p.product_slack,
          product_code: p.product_code,
          label: p.label || p.name,
          purchase_amount_excluding_tax: p.purchase_amount_excluding_tax,
          tax_percentage: p.tax_percentage,
          tax_type: p.tax_type,
          Supplier: p.Supplier || null,
          meta_data: p?.meta_data || []
        }))
      : []
    return { success: true, data: products }
  }
  return { success: false, data: [] }
}

export const createInvoice = (response) => {
  if (response && response.data) {
    return {
      success: response.data.success === true,
      message: response.data.message || 'Invoice created successfully',
      data: response.data.data || null
    }
  }
  return { success: false, message: 'Failed to create invoice', data: null }
}
